import icon01 from '@/assets//images/analytics/icon-01.svg'
import icon02 from '@/assets/images/analytics/icon-02.svg'
import icon03 from '@/assets/images/analytics/icon-03.svg'
import icon04 from '@/assets/images/analytics/icon-04.svg'
import icon05 from '@/assets/images/analytics/icon-05.svg'
import icon06 from '@/assets/images/analytics/icon-06.svg'
import icon07 from '@/assets/images/analytics/icon-07.svg'
import icon08 from '@/assets/images/analytics/icon-08.svg'

export default {
	general:
		[
			{
				id: 1,
				name: "ЭИ-профиль",
				keys: "",
				description: "Анализирует результаты тестирования выбранной группы: средние показатели по всем метрикам, распределения по уровням развития и ключевые сильные/слабые зоны.",
				link: "/analytics/repeated",
				available: true,
				type: 'repeated',
			},
			{
				id: 2,
				name: "Сравнение групп",
				keys: "",
				description: "Сопоставляет две группы по тем же ключевым метрикам, показывая различия в уровнях развития, профилях и доминирующих компетенциях.",
				link: "/analytics/group",
				available: false,
				type: 'group',
			},
			{
				id: 3,
				name: "Аналитика изменений в ЭИ",
				keys: "",
				description: "Сравнивает показатели одной и той же группы между первичным и повторным проходами теста, показывая изменения после обучения или других вмешательств.",
				link: "/analytics/dynamic",
				available: false,
				type: 'dynamic',
			},
			{
				id: 4,
				name: "Сравнение с бенчмарком по отрасли",
				keys: "",
				description: "Показывает средние значения по 17 параметрам ЭИ для конкретной должности в выбранной отрасли и позволяет соотносить сотрудников или группы с эталоном отрасли. Используется для оценки соответствия кандидатов отраслевому тренду и визуального анализа ключевых параметров.",
				link: "/analytics/benchmark",
				available: false,
				type: 'benchmark',
			},
		],
		special: [
		{
			id: 8,
			name: "Эталонный профиль",
			keys: "",
			description: "Определяет, какие параметры ЭИ связаны с высоким достижением KPI на конкретной должности, и формирует эталон компетенций на основе данных минимум 60 сотрудников. Позволяет сравнивать результаты сотрудников с эталоном и классифицировать их по уровню соответствия.",
			link: "/references/list",
			available: true,
			product_id: 'reference_profile',
		},
	],
		admin: [
		{
			id: 7,
			icon: "fa-table",
			name: "Сводная таблица по доступным курсам/тестам",
			keys: "",
			description: "",
			link: "/analytics/summary"
		},
		{
			id: 8,
			icon: "fa-table",
			name: "Подробный отчёт по курсам/тестам",
			keys: "",
			description: "",
			link: "/analytics/general"
		},
		{
			id: 9,
			icon: "fa-table",
			name: "Данные по тестированиям",
			keys: "",
			description: "",
			link: "/analytics/testing_data",
			type: "testing_data"
		}
	]
}
